// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"f13d993a","129":"0a7009db","563":"424ac775","592":"3cb09de4","763":"2abba63e"}[chunkId] + ".chunk.js";
};